import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LoadingOverlay, Loader, ActionIcon } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { error400, error404, error500, errorgeneric } from '../../../images';

const CustomLoader = ({
  isLoading,
  error,
  errorCode,
  errorTitle = 'Something went wrong.',
  errorSubtitle = "Sorry, we couldn't find your page."
}) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const reload = () => {
    window.location.reload();
  };

  if (error)
    return (
      <div className="max-w-[50rem] flex flex-col mx-auto w-full h-full">
        <header className="mb-auto flex-col justify-center align-center z-50 w-full py-4">
          <nav className="px-4 sm:px-6 lg:px-8" aria-label="Global">
          </nav>
        </header>
        <div className="text-center py-10 px-4 sm:px-6 lg:px-8 pt-0 flex justify-center items-center flex-col">
          <a
            className="flex-none text-xl font-semibold sm:text-3xl mb-4"
            href="#"
            aria-label="Brand"
          >
            Oops!
          </a>
          <img src={errorCode === 400 ? error400 : errorCode === 404 ? error404 : errorCode === 500 ? error500 : errorgeneric} alt="" style={{ height: '480px' }} className="mb-4" />

          <h1 className="block text-2xl font-bold text-white" />
          <p className="mt-3 font-extrabold">{errorTitle}</p>
          <p className="font-extrabold">{errorSubtitle}</p>

          <div className="mt-5 flex flex-col justify-center items-center gap-2 sm:flex-row sm:gap-3">
            <span
              onClick={reload}
              className="cursor-pointer w-full sm:w-auto inline-flex justify-center items-center gap-x-3 text-center bg-green-600 hover:bg-green-700 border border-transparent text-white text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-white transition py-3 px-4 dark:focus:ring-offset-gray-800"
              target="_blank"
            >
              <IconRefresh size={16} style={{ marginRight: 4 }} />
              Reload
            </span>
            <span
              onClick={goBack}
              className="cursor-pointer w-full sm:w-auto inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold text-green-600 hover:text-green-800 focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm py-3 px-4 dark:ring-offset-slate-900"
            >
              <svg
                className="w-2.5 h-2.5"
                width={16}
                height={16}
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M11.2792 1.64001L5.63273 7.28646C5.43747 7.48172 5.43747 7.79831 5.63273 7.99357L11.2792 13.64"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                />
              </svg>
              Go back
            </span>
          </div>
        </div>
        <footer className="mt-auto text-center py-5">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"></div>
        </footer>
      </div>
    );

  if (isLoading) return <Loader color="blue" />;
};

export default function RequestOverlay({
  overlayBlur = 20,
  isLoading,
  error,
  errorCode = null,
  id,
  errorTitle,
  errorSubtitle
}) {
  return (
    <LoadingOverlay
      id={id}
      className="z-20"
      visible={isLoading || error}
      overlayBlur={overlayBlur}
      loader={
        <CustomLoader
          errorTitle={errorTitle}
          errorSubtitle={errorSubtitle}
          error={error}
          errorCode={errorCode}
          isLoading={isLoading}
        />
      }
    />
  );
}
